export default __webpack_public_path__ + "static/media/profileImage.43d28fcc.svg";